export default __webpack_public_path__ + "static/media/peso.a0e52966.png";